import React, { useState, useEffect } from "react";
import moment from "moment";
import Spinner from "react-bootstrap/Spinner";

import afterLoginApiAxios from "../../Util/API Calls/afterLogin";
import CloseIconWithText from "../../assets/close_icon.png";
import deletRedIcon from "../../assets/delet_red_icon.svg";
import Info from "../../assets/info.png";
import Select, { components } from "react-select";
import {
  disableHelpButton,
  enableHelpButton,
} from "../common/DisableHelpButton/DisableHelpButton";
import closeIcon from "../../assets/forhomepage/close_icon.svg";
import MarkCheckInSuccessModal from "./modal-mark-check-in-success";

import Drawer from "@material-ui/core/Drawer";
import "./modalmarkcheckin.css";
import Loader from "../UI Component/Loader/Loader";
import CustomSelect from "../UI Component/CustomSelect/CustomSelect";
import DocumentContainer from "../UI Component/DocumentViewer/DocumentCotainer";
import swal from "sweetalert";
import { LOCALSTORAGEKEY } from "../../Util/Helper/localStorageUtils";
import { C2CConsole } from "../../Util/Helper/C2CConsole";

export default function MarkCheckInModal(props) {
  const [appointmentDetails, setAppointmentDetails] = useState({});
  const [totalRefund, setTotalRefund] = useState(0);
  const [appntPayTransId, setAppntPayTransId] = useState(null);
  const [disableSubmit, setDisableSubmit] = useState(false);
  const [loading, setLoading] = useState(false);
  const [isSpecifyOther, setSpecifyOther] = useState(false);
  const [showSuccessMarkModal, setSuccessMarkModal] = useState(false);
  const [paymentMethod, setPaymentMethod] = useState("");
  const [hidePaymentMode, setHidePaymentMethod] = useState(false);
  const [referenceId, setReferenceId] = useState("");
  const [specifyOtherPaymentText, setSpecifyOtherPaymentText] = useState("");
  const [invoiceUrl, setInvoiceUrl] = useState("");
  const [completionTime, setCompletionTime] = useState(null);
  const [procedureRows, setProcedureRows] = useState([]);
  const [getDoctorConsultationTypeList, setGetDoctorConsultationTypeList] =
    useState([]);
  const [newProcedureDetails, setNewProcedureDetails] = useState([
    {
      cgst_percent: null,
      consultation_fee_in_rupees: 0,
      consultation_name: "",
      consultation_type: "",
      convenience_fee_in_rupees: null,
      discount_on_consultation_fee_in_rupees: 0,
      discount_percent: 0,
      fee_in_rupees: 0,
      gst_in_rupees: null,
      igst_percent: null,
      inputValue: 0,
      procedure_id: "",
      procedure_name: "",
      sgst_percent: null,
      subtotal_in_rupees: 0,
      total_fee_in_rupees: 0,
      refund_in_rupees: 0,
      final_amount_in_rupees: 0,
    },
  ]);
  const [loader, setloader] = useState(false);
  const [procedureTrue, setProcedureTrue] = useState(false);
  const [inputValue, setInputValue] = useState("");
  const [amountToBePaidAtClinic, setAmountToBePaidAtClinic] = useState(0);
  const [consultationFeeInRupeesAtClinic, setConsultationFeeInRupeesAtClinic] =
    useState(0);
  const [discountAtClinic, setDiscountAtClinic] = useState(0);
  const [slectValue, setSlectValue] = useState("");
  const [fileDetails, setFileDetails] = useState({
    fileURL: "",
    fileName: "Invoice for Your Connect2Clinic appointment",
    fileType: ".pdf",
  });
  const [documentShow, setDocumentShow] = useState(false);

  // Varible
  let isStaff = localStorage.getItem("user_type");
  let staffId = localStorage.getItem(LOCALSTORAGEKEY.STAFF_ID);
  const clinicId = localStorage.getItem(LOCALSTORAGEKEY.CLINIC_ID);
  const userId = localStorage.getItem(LOCALSTORAGEKEY.USER_ID);

  // let totalFeeCalculated = paidAmount + amountToBePaidAtClinic;

  const defoultProcedureOtions = [
    { value: "6", label: "In-clinic Follow-up" },
    { value: "5", label: "In-clinic Regular" },
  ];

  function renderConsultationType(
    appointmentType,
    consultationType,
    procedureName
  ) {
    let appointmentTypeText =
      appointmentType === "in-clinic" ? "In-Clinic" : "Tele-Consult";
    switch (consultationType) {
      case "regular":
        return <span>{appointmentTypeText + " Regular"}</span>;
      case "followup":
        return <span>{appointmentTypeText + " Follow-Up"}</span>;
      case "procedure":
        return <span>{procedureName}</span>;
      case "instant":
        return <span>Instant</span>;
      default:
        return "";
    }
  }

  //function to apply discount

  let regexPattern = "^[1-9]$|^[1-9][0-9]$|^(100)$";

  function applyDiscount(e, index) {
    let value = e.target.value
      ? Number(e.target.value.replace("%", "").trim())
      : 0;
    if (value <= 100) {
      let payableFee = procedureRows[index].fee_in_rupees;
      let inputValue = value ? Number(value) : 0;
      let newFee = payableFee * (inputValue / 100);
      let lowerLimitFloat = Number(newFee).toFixed(1);
      let lowerLimit = parseFloat(lowerLimitFloat);
      const finalCost = newFee > lowerLimit ? newFee : lowerLimit;
      let totalFee =
        inputValue !== null
          ? payableFee - finalCost > 0
            ? parseFloat((payableFee - finalCost).toFixed(1))
            : 0
          : payableFee;
      if (procedureRows[index]["refund_in_rupees"] <= totalFee) {
        procedureRows[index]["fee_in_rupees"] = payableFee;
        procedureRows[index]["total_fee_in_rupees"] = totalFee;
        procedureRows[index]["discount_on_consultation_fee_in_rupees"] =
          parseFloat(finalCost.toFixed(1));
        procedureRows[index]["discount_percent"] = inputValue;
        procedureRows[index]["consultation_fee_in_rupees"] =
          procedureRows.reduce(
            (a, v) => (a = a + (!v.is_deleted ? v.fee_in_rupees : 0)),
            0
          );
        procedureRows[index]["final_amount_in_rupees"] = parseFloat(
          (
            Number(procedureRows[index].total_fee_in_rupees) -
            Number(procedureRows[index].refund_in_rupees)
          ).toFixed(1)
        );
        setProcedureRows(procedureRows);

        let byCash =
          appointmentDetails.payment_method === "Paid at Clinic - By Cash";
        let fee = appointmentDetails.fee_in_rupees;
        let discount = appointmentDetails.discount_percent;
        let discount_fee =
          appointmentDetails.discount_on_consultation_fee_in_rupees;
        let final_amount = appointmentDetails.final_amount_in_rupees;
        setAmountToBePaidAtClinic(
          procedureRows.reduce(
            (a, v) => (a = a + (!v.is_deleted ? v.final_amount_in_rupees : 0)),
            0
          ) + (byCash ? final_amount : 0)
        );
        setConsultationFeeInRupeesAtClinic(
          procedureRows.reduce(
            (a, v) => (a = a + (!v.is_deleted ? v.fee_in_rupees : 0)),
            0
          ) + (byCash ? fee : 0)
        );
        setDiscountAtClinic(
          procedureRows.reduce(
            (a, v) =>
              (a =
                a +
                (!v.is_deleted ? v.discount_on_consultation_fee_in_rupees : 0)),
            0
          ) + (byCash ? discount_fee : 0)
        );
        setInputValue(
          procedureRows.reduce(
            (a, v) => (a = a + (!v.is_deleted ? v.discount_percent : 0)),
            0
          ) + (byCash ? discount : 0)
        );

        let prope = e.target.attributes.column.value; // the custom column attribute
        let indexing = e.target.attributes.index.value; // index of state array -rows
        let fieldValue = e.target.value; // value

        const tempRows = [...procedureRows]; // avoid direct state mutation
        const tempObj = procedureRows[indexing]; // copy state object at index to a temporary object
        tempObj["inputValue"] = fieldValue; // modify temporary object
        tempObj[prope] = fieldValue;

        tempRows[indexing] = tempObj;
        setProcedureRows(tempRows);
      } else {
        alert("Refund cannot be more than total amount");
      }
    } else {
      alert("More than 100%");
    }
  }

  function applyFee(e, index) {
    let payableFee = e.target.value ? Number(e.target.value) : 0;
    let inputValue = procedureRows[index].discount_percent
      ? procedureRows[index].discount_percent
      : 0;
    let newFee = payableFee * (inputValue / 100);
    let lowerLimitFloat = Number(newFee).toFixed(1);
    let lowerLimit = parseFloat(lowerLimitFloat);
    const finalCost = newFee > lowerLimit ? newFee : lowerLimit;
    let totalFee =
      inputValue !== null
        ? payableFee - finalCost > 0
          ? parseFloat((payableFee - finalCost).toFixed(1))
          : 0
        : payableFee;
    if (procedureRows[index]["refund_in_rupees"] <= totalFee) {
      procedureRows[index].fee_in_rupees = payableFee;
      procedureRows[index].subtotal_in_rupees = payableFee;
      procedureRows[index]["total_fee_in_rupees"] = totalFee;
      procedureRows[index]["final_amount_in_rupees"] = parseFloat(
        (
          Number(procedureRows[index].total_fee_in_rupees) -
          Number(procedureRows[index].refund_in_rupees)
        ).toFixed(1)
      );
      procedureRows[index]["discount_on_consultation_fee_in_rupees"] =
        parseFloat(finalCost.toFixed(1));
      procedureRows[index]["discount_percent"] = inputValue;
      procedureRows[index]["consultation_fee_in_rupees"] = procedureRows.reduce(
        (a, v) => (a = a + (!v.is_deleted ? v.fee_in_rupees : 0)),
        0
      );
      setProcedureRows(procedureRows);

      let byCash =
        appointmentDetails.payment_method === "Paid at Clinic - By Cash";
      let fee = appointmentDetails.fee_in_rupees;
      let discount = appointmentDetails.discount_percent;
      let discount_fee =
        appointmentDetails.discount_on_consultation_fee_in_rupees;
      let final_amount = appointmentDetails.final_amount_in_rupees;
      setAmountToBePaidAtClinic(
        procedureRows.reduce(
          (a, v) => (a = a + (!v.is_deleted ? v.final_amount_in_rupees : 0)),
          0
        ) + (byCash ? final_amount : 0)
      );
      setConsultationFeeInRupeesAtClinic(
        procedureRows.reduce(
          (a, v) => (a = a + (!v.is_deleted ? v.fee_in_rupees : 0)),
          0
        ) + (byCash ? fee : 0)
      );
      setDiscountAtClinic(
        procedureRows.reduce(
          (a, v) =>
            (a =
              a +
              (!v.is_deleted ? v.discount_on_consultation_fee_in_rupees : 0)),
          0
        ) + (byCash ? discount_fee : 0)
      );
      setInputValue(
        procedureRows.reduce(
          (a, v) => (a = a + (!v.is_deleted ? v.discount_percent : 0)),
          0
        ) + (byCash ? discount : 0)
      );
    } else {
      alert("Refund cannot be more than total amount");
    }
  }

  function applyRefund(e, index) {
    let newValue = e.target.value ? Number(e.target.value) : 0;
    if (newValue <= Number(procedureRows[index].total_fee_in_rupees)) {
      let refund = 0;
      procedureRows[index].refund_in_rupees = newValue;
      procedureRows[index].final_amount_in_rupees = parseFloat(
        (
          Number(procedureRows[index].total_fee_in_rupees) - Number(newValue)
        ).toFixed(1)
      );
      procedureRows.forEach((pr) => {
        refund += pr.refund_in_rupees ? pr.refund_in_rupees : 0;
      });
      setProcedureRows(procedureRows);
      setTotalRefund(Number(refund + appointmentDetails.refund_in_rupees));
      let byCash =
        appointmentDetails.payment_method === "Paid at Clinic - By Cash";
      setAmountToBePaidAtClinic(
        procedureRows.reduce(
          (a, v) => (a = a + (!v.is_deleted ? v.final_amount_in_rupees : 0)),
          0
        ) + (byCash ? appointmentDetails.final_amount_in_rupees : 0)
      );
    } else {
      alert("Refund cannot be more than total amount");
    }
  }

  function applyDefaultFee(e) {
    let feeValue = e.target.value ? Number(e.target.value) : 0;
    let appntDetails = appointmentDetails;
    let byCash =
      appointmentDetails.payment_method === "Paid at Clinic - By Cash";
    let refundAmount = appntDetails.refund_in_rupees;
    let discount = appntDetails.discount_percent;
    let value = discount ? discount : 0;
    let newFee = feeValue * (value / 100);
    let lowerLimitFloat = Number(newFee).toFixed(1);
    let lowerLimit = parseFloat(lowerLimitFloat);
    const finalCost = newFee > lowerLimit ? newFee : lowerLimit;
    let total =
      value !== null
        ? feeValue - finalCost > 0
          ? parseFloat((feeValue - finalCost).toFixed(1))
          : 0
        : feeValue;
    if (refundAmount <= Number(total)) {
      appntDetails.fee_in_rupees = feeValue;
      appntDetails.subtotal_in_rupees = feeValue;
      appntDetails.total_fee_in_rupees = total;
      appntDetails.discount_on_consultation_fee_in_rupees = parseFloat(
        finalCost.toFixed(1)
      );
      appntDetails.consultation_fee_in_rupees = byCash
        ? feeValue
        : appntDetails.consultation_fee_in_rupees;
      appntDetails.final_amount_in_rupees = parseFloat(
        (Number(total) - Number(refundAmount ? refundAmount : 0)).toFixed(1)
      );
      setAppointmentDetails(appntDetails);
      setAmountToBePaidAtClinic(
        procedureRows.reduce(
          (a, v) => (a = a + (!v.is_deleted ? v.final_amount_in_rupees : 0)),
          0
        ) + (byCash ? appntDetails.final_amount_in_rupees : 0)
      );
      setConsultationFeeInRupeesAtClinic(
        procedureRows.reduce(
          (a, v) => (a = a + (!v.is_deleted ? v.fee_in_rupees : 0)),
          0
        ) + (byCash ? feeValue : 0)
      );
      setDiscountAtClinic(
        procedureRows.reduce(
          (a, v) =>
            (a =
              a +
              (!v.is_deleted ? v.discount_on_consultation_fee_in_rupees : 0)),
          0
        ) + (byCash ? appntDetails.discount_on_consultation_fee_in_rupees : 0)
      );
      setInputValue(
        procedureRows.reduce(
          (a, v) => (a = a + (!v.is_deleted ? v.discount_percent : 0)),
          0
        ) + (byCash ? discount : 0)
      );
    } else {
      alert("Refund cannot be more than total amount");
    }
  }

  function applyDefaultDiscount(e) {
    let value = e.target.value
      ? Number(e.target.value.replace("%", "").trim())
      : 0;
    let appntDetails = appointmentDetails;
    let refundAmount = appntDetails.refund_in_rupees;
    let fee = appntDetails.fee_in_rupees;
    if (value <= 100) {
      let newFee = fee * (value / 100);
      let lowerLimitFloat = Number(newFee).toFixed(1);
      let lowerLimit = parseFloat(lowerLimitFloat);
      const finalCost = newFee > lowerLimit ? newFee : lowerLimit;
      let total =
        value !== null
          ? fee - finalCost > 0
            ? parseFloat((fee - finalCost).toFixed(1))
            : 0
          : fee;
      if (refundAmount <= Number(total)) {
        appntDetails.discount_percent = value;
        appntDetails.total_fee_in_rupees = total;
        appntDetails.discount_on_consultation_fee_in_rupees = parseFloat(
          finalCost.toFixed(1)
        );
        appntDetails.final_amount_in_rupees = parseFloat(
          (
            Number(total ? total : 0) - Number(refundAmount ? refundAmount : 0)
          ).toFixed(1)
        );
        let byCash =
          appointmentDetails.payment_method === "Paid at Clinic - By Cash";
        setAmountToBePaidAtClinic(
          procedureRows.reduce(
            (a, v) => (a = a + (!v.is_deleted ? v.final_amount_in_rupees : 0)),
            0
          ) + (byCash ? appntDetails.final_amount_in_rupees : 0)
        );
        setConsultationFeeInRupeesAtClinic(
          procedureRows.reduce(
            (a, v) => (a = a + (!v.is_deleted ? v.fee_in_rupees : 0)),
            0
          ) + (byCash ? fee : 0)
        );
        setDiscountAtClinic(
          procedureRows.reduce(
            (a, v) =>
              (a =
                a +
                (!v.is_deleted ? v.discount_on_consultation_fee_in_rupees : 0)),
            0
          ) + (byCash ? appntDetails.discount_on_consultation_fee_in_rupees : 0)
        );
        setInputValue(
          procedureRows.reduce(
            (a, v) => (a = a + (!v.is_deleted ? v.discount_percent : 0)),
            0
          ) + (byCash ? value : 0)
        );
      } else {
        alert("Refund cannot be more than total amount");
      }
    } else {
      alert("More than 100%");
    }
  }

  function applyDefaultRefund(e) {
    let refundValue = e.target.value ? Number(e.target.value) : 0;
    let appntDetails = appointmentDetails;
    let paidAmount = appntDetails.total_fee_in_rupees;
    if (refundValue <= Number(paidAmount)) {
      let refund = 0;
      procedureRows.forEach((pr) => {
        refund += pr.refund_in_rupees ? pr.refund_in_rupees : 0;
      });
      appntDetails.refund_in_rupees = refundValue;
      appntDetails.final_amount_in_rupees = parseFloat(
        (Number(paidAmount ? paidAmount : 0) - Number(refundValue)).toFixed(1)
      );
      setTotalRefund(refund + refundValue);
      let byCash =
        appointmentDetails.payment_method === "Paid at Clinic - By Cash";
      setAmountToBePaidAtClinic(
        procedureRows.reduce(
          (a, v) => (a = a + (!v.is_deleted ? v.final_amount_in_rupees : 0)),
          0
        ) + (byCash ? appointmentDetails.final_amount_in_rupees : 0)
      );
    } else {
      alert("Refund cannot be more than total amount");
    }
  }

  useEffect(() => {
    setAmountToBePaidAtClinic(0);
    if (props.openView) {
      disableHelpButton();
      // setLoading(true);
      setPaymentMethod("");
      setProcedureRows([]);
      setNewProcedureDetails([
        {
          cgst_percent: null,
          consultation_fee_in_rupees: 0,
          consultation_name: "",
          consultation_type: "",
          convenience_fee_in_rupees: null,
          discount_on_consultation_fee_in_rupees: 0,
          discount_percent: 0,
          fee_in_rupees: 0,
          gst_in_rupees: null,
          igst_percent: null,
          inputValue: 0,
          procedure_id: "",
          procedure_name: "",
          sgst_percent: null,
          subtotal_in_rupees: 0,
          total_fee_in_rupees: 0,
          refund_in_rupees: 0,
          final_amount_in_rupees: 0,
        },
      ]);
      if (props.edit_receipt) {
        fetchEditAppointmentDetails();
      } else {
        fetchAppointmentDetails();
      }
    }
    return () => {
      enableHelpButton();
    };
  }, [props.openView]);

  useEffect(() => {
    if (props.openView) {
      let api = "/public/get-doctor-consultation-type-list";
      if (clinicId) {
        api = "/clinic/get-clinic-consultation-type-list";
      }
      afterLoginApiAxios({
        method: "post",
        url: api,
        headers: {
          authorization: localStorage.getItem("id_token"),
        },
        data: {
          doctor_id: props?.doctor_id,
          clinic_id: clinicId,
        },
      })
        .then((response) => {
          if (response.status === 200) {
            let arrayTwo = response.data.doctor_consultation_detail;
            let tempArray = arrayTwo.filter(
              (res) => res.consultation_name === "Procedure"
            );

            if (tempArray.length > 0) {
              const newFile = tempArray[0].procedure_list?.map((file) => {
                return { ...file, value: "4" };
              });

              const transformed = newFile.map(
                ({ value, procedure_id: id, procedure_name: label }) => ({
                  value,
                  id,
                  label,
                })
              );
              let doctor_consultation_detail_arry = [
                ...defoultProcedureOtions,
                ...transformed,
              ];
              setGetDoctorConsultationTypeList(doctor_consultation_detail_arry);
            } else {
              setGetDoctorConsultationTypeList(defoultProcedureOtions);
            }
          }
        })
        .catch((error) => {
          C2CConsole.error(error);
        });
    }
  }, [userId, props.openView]);

  function fetchEditAppointmentDetails() {
    setLoading(true);
    afterLoginApiAxios
      .post(
        "/doctor/get-check-in-details",
        {
          doctor_id: props?.doctor_id,
          appointment_id: props.appointment_id,
          staff_id: staffId,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: localStorage.getItem("id_token"),
          },
        }
      )
      .then((response) => {
        if (response.data) {
          if (response.data.statusCode == "200") {
            let data = response.data;
            setLoading(false);
            setAppntPayTransId(data?.appointment_payment_transaction_id);
            setPaymentMethod(data?.inclinic_payment_mode);
            setReferenceId(data?.inclinic_payment_reference);
            setAppointmentDetails({
              ...data?.original_appointment_details,
              refund_in_rupees: Number(
                data?.original_appointment_details.refund_in_rupees
              ),
              final_amount_in_rupees: Number(
                data?.original_appointment_details.final_amount_in_rupees
              ),
            });

            if (
              data?.original_appointment_details?.payment_method ===
                "Paid at Clinic - By Cash" ||
              data?.additional_procedure_details.length !== 0
            ) {
              setHidePaymentMethod(false);
            } else {
              setHidePaymentMethod(true);
            }
            let markers = [...newProcedureDetails];
            let procedureRowsmarkers = [];
            if (data?.additional_procedure_details.length !== 0) {
              setProcedureTrue(true);
              data.additional_procedure_details.forEach((apd) => {
                markers.push({
                  ...apd,
                  cgst_percent: apd.cgst_percent ? apd.cgst_percent : 0,
                  consultation_fee_in_rupees: apd.consultation_fee_in_rupees,
                  consultation_name: apd.consultation_name,
                  consultation_type: apd.consultation_type,
                  convenience_fee_in_rupees: 0,
                  discount_on_consultation_fee_in_rupees:
                    apd.discount_on_consultation_fee_in_rupees,
                  discount_percent: apd.discount_percent,
                  fee_in_rupees: apd.fee_in_rupees,
                  gst_in_rupees: 0,
                  igst_percent: apd.igst_percent ? apd.igst_percent : 0,
                  inputValue: 0,
                  procedure_id: apd.procedure_id,
                  procedure_name: apd.procedure_name,
                  sgst_percent: apd.sgst_percent ? apd.sgst_percent : 0,
                  subtotal_in_rupees: apd.subtotal_in_rupees,
                  total_fee_in_rupees: apd.total_fee_in_rupees,
                  refund_in_rupees: apd.refund_in_rupees
                    ? apd.refund_in_rupees
                    : 0,
                  final_amount_in_rupees: apd.final_amount_in_rupees,
                  is_deleted: false,
                });
                procedureRowsmarkers.push({
                  ...apd,
                  cgst_percent: apd.cgst_percent ? apd.cgst_percent : 0,
                  consultation_fee_in_rupees: apd.consultation_fee_in_rupees,
                  consultation_name: apd.consultation_name,
                  consultation_type: apd.consultation_type,
                  convenience_fee_in_rupees: 0,
                  discount_on_consultation_fee_in_rupees:
                    apd.discount_on_consultation_fee_in_rupees,
                  discount_percent: apd.discount_percent,
                  fee_in_rupees: apd.fee_in_rupees,
                  gst_in_rupees: 0,
                  igst_percent: apd.igst_percent ? apd.igst_percent : 0,
                  inputValue: 0,
                  procedure_id: apd.procedure_id,
                  procedure_name: apd.procedure_name,
                  sgst_percent: apd.sgst_percent ? apd.sgst_percent : 0,
                  subtotal_in_rupees: apd.subtotal_in_rupees,
                  total_fee_in_rupees: apd.total_fee_in_rupees,
                  refund_in_rupees: apd.refund_in_rupees
                    ? apd.refund_in_rupees
                    : 0,
                  final_amount_in_rupees: apd.final_amount_in_rupees,
                  is_deleted: false,
                });
              });
            }
            let byCash =
              data?.original_appointment_details.payment_method ===
              "Paid at Clinic - By Cash";

            let method = paymentOptions.find(
              (ele) => ele.value === data?.inclinic_payment_mode
            );

            if (
              byCash &&
              !method &&
              data?.inclinic_payment_mode !== "Paid at Clinic - By Cash"
            ) {
              setSpecifyOther(true);
              setSpecifyOtherPaymentText(data?.inclinic_payment_mode);
            } else {
              setSpecifyOther(false);
              setSpecifyOtherPaymentText("");
            }

            setAmountToBePaidAtClinic(
              procedureRowsmarkers.reduce(
                (a, v) =>
                  (a = a + (!v.is_deleted ? v.final_amount_in_rupees : 0)),
                0
              ) +
                (byCash
                  ? Number(
                      data?.original_appointment_details.final_amount_in_rupees
                    )
                  : 0)
            );
            setConsultationFeeInRupeesAtClinic(
              procedureRowsmarkers.reduce(
                (a, v) => (a = a + (!v.is_deleted ? v.fee_in_rupees : 0)),
                0
              ) +
                (byCash ? data?.original_appointment_details.fee_in_rupees : 0)
            );
            setDiscountAtClinic(
              procedureRowsmarkers.reduce(
                (a, v) =>
                  (a =
                    a +
                    (!v.is_deleted
                      ? v.discount_on_consultation_fee_in_rupees
                      : 0)),
                0
              ) +
                (byCash
                  ? data?.original_appointment_details
                      .discount_on_consultation_fee_in_rupees
                  : 0)
            );
            setInputValue(
              procedureRowsmarkers.reduce(
                (a, v) => (a = a + (!v.is_deleted ? v.discount_percent : 0)),
                0
              ) +
                (byCash
                  ? data?.original_appointment_details.discount_percent
                  : 0)
            );
            let refund = 0;
            procedureRowsmarkers.forEach((pr) => {
              refund += pr.refund_in_rupees ? pr.refund_in_rupees : 0;
            });
            setTotalRefund(
              Number(refund) +
                Number(data?.original_appointment_details.refund_in_rupees)
            );
            setProcedureRows(procedureRowsmarkers);
            setNewProcedureDetails(markers);
          } else {
            setLoading(false);
            setReferenceId("");
            // TODO: Error handling and logging
          }
        } else {
          setLoading(false);
          setReferenceId("");
          // TODO: Error handling and logging
        }
      })
      .catch((err) => C2CConsole.log(err));
  }

  function fetchAppointmentDetails() {
    setLoading(true);
    afterLoginApiAxios
      .post(
        "/doctor/get-appointment-details-by-id",
        { appointment_id: props.appointment_id },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: localStorage.getItem("id_token"),
          },
        }
      )
      .then((response) => {
        if (response.data) {
          if (response.data.statusCode == "200") {
            let data = response.data.appointment_details;
            data.cgst_percent = data.cgst_percent ? data.cgst_percent : 0;
            data.consultation_fee_in_rupees = data.consultation_fee_in_rupees
              ? data.consultation_fee_in_rupees
              : 0;
            data.convenience_fee_in_rupees = data.convenience_fee_in_rupees
              ? data.convenience_fee_in_rupees
              : 0;
            data.discount_on_consultation_fee_in_rupees =
              data.discount_on_consultation_fee_in_rupees
                ? data.discount_on_consultation_fee_in_rupees
                : 0;
            data.discount_percent = data.discount_percent
              ? data.discount_percent
              : 0;
            data.fee_in_rupees = data.fee_in_rupees ? data.fee_in_rupees : 0;
            data.refund_in_rupees = 0;
            data.final_amount_in_rupees = data.total_fee_in_rupees
              ? data.total_fee_in_rupees
              : 0;
            data.gst_in_rupees = data.gst_in_rupees ? data.gst_in_rupees : 0;
            data.igst_percent = data.igst_percent ? data.igst_percent : 0;
            data.sgst_percent = data.sgst_percent ? data.sgst_percent : 0;
            data.subtotal_in_rupees = data.subtotal_in_rupees
              ? data.subtotal_in_rupees
              : 0;
            data.total_fee_in_rupees = data.total_fee_in_rupees
              ? data.total_fee_in_rupees
              : 0;
            setLoading(false);
            setPaymentMethod(data.payment_method);
            setAppointmentDetails(data);
            if (data.payment_method === "Paid at Clinic - By Cash") {
              setHidePaymentMethod(false);
              setConsultationFeeInRupeesAtClinic(data.fee_in_rupees);
              setDiscountAtClinic(data.discount_on_consultation_fee_in_rupees);
              setInputValue(data.discount_percent);
              setAmountToBePaidAtClinic(data.total_fee_in_rupees);
            } else {
              setHidePaymentMethod(true);
            }

            C2CConsole.log(
              "response.data.statusCode===>",
              response.data,
              response.data.appointment_details.paid_amount,
              data
            );
          } else {
            setLoading(false);
            // TODO: Error handling and logging
          }
        } else {
          setLoading(false);
          // TODO: Error handling and logging
        }
      })
      .catch((err) => C2CConsole.log(err));
  }
  const paymentOptions = [
    { value: "Cash", label: "By Cash" },
    { value: "Google Pay", label: "By Google Pay" },
    { value: "Paytm", label: "By Paytm" },
    { value: "PhonePe", label: "By PhonePe" },
    { value: "Credit/Debit Card", label: "By Credit/Debit Card" },
    { value: "Netbanking", label: "By Netbanking" },
    { value: "Amazon Pay", label: "By Amazon Pay" },
    { value: "Other", label: "Other" },
  ];

  const customStyles = {
    control: (base) => ({
      ...base,
      width: "100%",
      background: " #F5F6F7 0% 0% no-repeat padding-box",
      boxShadow: "none",
      border: "none",
      cursor: "pointer",
      height: "20px",
      "&:hover": {
        boxShadow: "none",
      },
    }),
    container: (base) => ({
      ...base,
      width: "100%",
      textAlign: "left",
    }),
    placeholder: (styles, { data }) => {
      return {
        ...styles,
        fontSize: "14px",
      };
    },
    menuList: (provided) => ({
      ...provided,
      maxHeight: "100px",
      "&::-webkit-scrollbar": {
        width: "16px",
        height: " 16px",
        display: "block !important",
        background: "none",
      },
      "&::-webkit-scrollbar-track": {
        background: "none",
        borderRadius: "10px",
      },
      "&::-webkit-scrollbar-thumb": {
        boxShadow: "inset 0 0 16px rgba(240, 232, 232, 1)",
        minHeight: "60px !important",
      },
    }),
    singleValue: (provided) => ({
      ...provided,
      fontSize: "14px",
      color: "#1B2027",
    }),
    clearIndicator: (provided) => ({
      ...provided,
      background: "#f5f5f5",
    }),
    option: (provided, { data, isDisabled, isFocused, isSelected }) => {
      return {
        ...provided,
        cursor: "pointer",
        backgroundColor: isSelected ? "#17bae0" : null,
        color:
          data.value === "Other" ? "#17BAE0" : isSelected ? "#fff" : "#1B2027",
      };
    },
  };

  const DropdownIndicator = (props) => {
    return (
      components.DropdownIndicator && (
        <components.DropdownIndicator {...props}>
          {props.selectProps.menuIsOpen ? (
            <i className="fa fa-caret-up" style={{ color: "#17bae0" }}></i>
          ) : (
            <i className="fa fa-caret-down" style={{ color: "#17bae0" }}></i>
          )}
        </components.DropdownIndicator>
      )
    );
  };

  function renderConsultationType(appointmentType, consultationType) {
    let appointmentTypeText =
      appointmentType === "in-clinic" ? "In-Clinic" : "Tele-Consult";
    switch (consultationType) {
      case "regular":
        return <span>{appointmentTypeText + " Regular"}</span>;
      case "followup":
        return <span>{appointmentTypeText + " Follow-Up"}</span>;
      case "procedure":
        return <span>{appointmentDetails.procedure_name}</span>;
      default:
        return "";
    }
  }
  const handleSelect = (paymentOption) => {
    if (paymentOption.label === "Other") {
      setSpecifyOther(true);
    }
    setPaymentMethod(paymentOption.value);
  };

  function markCheckIn(event) {
    event.preventDefault();
    setReferenceId("");
    let found = true;
    for (const i of procedureRows) {
      if (procedureRows[i].consultation_name === "") {
        found = false;
        break;
      }
    }
    if (found) {
      setLoading(true);
      let params = {};
      if (paymentMethod.toLocaleLowerCase !== "online") {
        params["inclinic_payment_mode"] = paymentMethod;
        params["inclinic_payment_reference"] = referenceId;
      } else {
        params["inclinic_payment_reference"] = "";
      }

      afterLoginApiAxios
        .post(
          props.edit_receipt
            ? "/api/v1/doctor/edit-check-in-details"
            : "/api/v1/doctor/raise-invoice-rev",
          {
            "authorizer-principal-id": {
              user_type: "1",
              user_id: isStaff === "staff" ? props?.doctor_id : userId,
            },
            ...params,
            inclinic_payment_mode: paymentMethod == "" ? "Cash" : paymentMethod,
            doctor_id: props?.doctor_id,
            appointment_id: props.appointment_id,
            staff_id: staffId,
            appointment_payment_transaction_id: props.edit_receipt
              ? appntPayTransId
              : null,
            original_appointment_details: appointmentDetails,
            additional_procedure_details: procedureRows,
            user_id: isStaff === "staff" ? props?.doctor_id : userId,
          },
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: localStorage.getItem("id_token"),
            },
          }
        )
        .then((response) => {
          if (response?.data && response?.data?.statusCode === 200) {
            setLoading(false);
            setInvoiceUrl(response?.data?.invoice_link);
            setFileDetails((prev) => ({
              ...prev,
              fileURL: response?.data?.invoice_link,
            }));
            let dateTime = response?.data?.marked_time?.split(".");
            setCompletionTime(
              response?.data?.marked_time != ""
                ? moment(dateTime[0]).format("MMM DD, YYYY hh:mm A")
                : null
            );
            setSuccessMarkModal(true);
            onRaiseInvoiceClose();
          } else {
            setLoading(false);
            setInvoiceUrl("");
            setFileDetails({
              fileName: "",
              fileURL: "",
              fileType: "",
            });
            setCompletionTime(null);
            setSuccessMarkModal(false);
            swal({
              title: "Sorry",
              text: response?.data?.message
                ? response?.data?.message
                : "Something Went Wrong. Please try again",
              icon: "warning",
            }).then(function () {});
          }
        })
        .catch((err) => {
          swal({
            title: "Sorry",
            text: "Something Went Wrong. Please try again",
            icon: "warning",
          }).then(function () {});
          C2CConsole.log(err);
        });
    } else {
      alert("either consultation name is incorrect or blank");
    }
  }

  // Add New ProcedureRow
  const addNewProcedureRow = () => {
    const item = {
      cgst_percent: 0,
      consultation_fee_in_rupees: 0,
      consultation_name: "",
      consultation_type: null,
      convenience_fee_in_rupees: 0,
      discount_on_consultation_fee_in_rupees: 0,
      discount_percent: 0,
      fee_in_rupees: 0,
      gst_in_rupees: 0,
      igst_percent: 0,
      inputValue: 0,
      procedure_id: "",
      procedure_name: "",
      sgst_percent: 0,
      subtotal_in_rupees: 0,
      total_fee_in_rupees: 0,
      refund_in_rupees: 0,
      final_amount_in_rupees: 0,
      is_deleted: false,
    };
    setProcedureRows([...procedureRows, item]);
    setNewProcedureDetails([...newProcedureDetails, item]);
    setHidePaymentMethod(false);
    setDisableSubmit(true);
  };

  // Remove Table row if rows are count is more than 1
  const deleteProcedureRows = (index) => {
    const tempRows = [...procedureRows];
    setAmountToBePaidAtClinic(
      amountToBePaidAtClinic - tempRows[index].final_amount_in_rupees
    );
    setConsultationFeeInRupeesAtClinic(
      consultationFeeInRupeesAtClinic - tempRows[index].fee_in_rupees
    );
    setDiscountAtClinic(
      discountAtClinic - tempRows[index].discount_on_consultation_fee_in_rupees
    );
    setInputValue(inputValue - tempRows[index].discount_percent);
    setTotalRefund(totalRefund - tempRows[index].refund_in_rupees);
    if (tempRows[index].check_in_id) {
      tempRows[index].is_deleted = true;
    } else {
      tempRows.splice(index, 1);
    }
    setProcedureRows(tempRows);
    if (appointmentDetails.payment_method !== "Paid at Clinic - By Cash") {
      if (tempRows.length === 0) {
        setHidePaymentMethod(true);
      } else {
        let hide = tempRows.every((tr) => tr.is_deleted);
        setHidePaymentMethod(hide);
      }
    }

    let disableSub = tempRows.every((tr) => tr.consultation_name !== "");
    setDisableSubmit(!disableSub);
    const newProcedureDetailsTemp = [...newProcedureDetails];
    if (newProcedureDetailsTemp[index].check_in_id) {
      newProcedureDetailsTemp[index].is_deleted = true;
    } else {
      newProcedureDetailsTemp.splice(index, 1);
    }
    setNewProcedureDetails(newProcedureDetailsTemp);

    if (procedureRows.length - 1 !== 0) {
    } else {
      setAmountToBePaidAtClinic(0);
      setConsultationFeeInRupeesAtClinic(0);
      setDiscountAtClinic(0);
      setInputValue(0);
      setPaymentMethod("online");
    }
  };

  const DoctorConsultationTypeListHandleSelect = (procedureValue, index) => {
    setSlectValue(procedureValue);
    setProcedureTrue(true);
    let setParms;
    if (procedureValue?.value === "4") {
      setParms = {
        procedure_id: procedureValue?.id,
        doctor_id: props?.doctor_id,
        consultation_type: procedureValue.value,
        staff_id: `${isStaff === "staff" ? staffId : ""}`,
        clinic_id: clinicId,
      };
    } else {
      setParms = {
        doctor_id: props?.doctor_id,
        consultation_type: procedureValue.value,
        staff_id: `${isStaff === "staff" ? staffId : ""}`,
        clinic_id: clinicId,
      };
    }
    setloader(true);
    afterLoginApiAxios
      .post("doctor/get-procedure-details-by-procedure-id", setParms, {
        headers: {
          "Content-Type": "application/json",
          Authorization: localStorage.getItem("id_token"),
        },
      })
      .then((response) => {
        C2CConsole.log(
          "response.data.data.consultation_type",
          response.data.data.consultation_type
        );
        if (response.data.statusCode === 200) {
          let consultation_type_value;
          if (response.data.data.consultation_type === "regular") {
            consultation_type_value = 5;
          } else if (response.data.data.consultation_type === "followup") {
            consultation_type_value = 6;
          } else {
            consultation_type_value = 4;
          }
          let markers = [...newProcedureDetails];
          markers[index] = {
            ...markers[index],
            cgst_percent: response.data.data.cgst_percent
              ? response.data.data.cgst_percent
              : 0,
            consultation_fee_in_rupees:
              response.data.data.consultation_fee_in_rupees,
            consultation_name: response.data.data.consultation_type,
            consultation_type: consultation_type_value,
            convenience_fee_in_rupees: 0,
            discount_on_consultation_fee_in_rupees: 0,
            discount_percent: 0,
            fee_in_rupees: response.data.data.fee_in_rupees,
            gst_in_rupees: 0,
            igst_percent: response.data.data.igst_percent
              ? response.data.data.igst_percent
              : 0,
            inputValue: 0,
            procedure_id: response.data.data.procedure_id,
            procedure_name: response.data.data.procedure_name,
            sgst_percent: response.data.data.sgst_percent
              ? response.data.data.sgst_percent
              : 0,
            subtotal_in_rupees: response.data.data.subtotal_in_rupees,
            total_fee_in_rupees: response.data.data.subtotal_in_rupees,
            refund_in_rupees: 0,
            final_amount_in_rupees: response.data.data.subtotal_in_rupees,
            is_deleted: false,
          };

          let procedureRowsmarkers = [...procedureRows];
          procedureRowsmarkers[index] = {
            ...procedureRowsmarkers[index],
            cgst_percent: response.data.data.cgst_percent
              ? response.data.data.cgst_percent
              : 0,
            consultation_fee_in_rupees:
              response.data.data.consultation_fee_in_rupees,
            consultation_name: response.data.data.consultation_type,
            consultation_type: consultation_type_value,
            convenience_fee_in_rupees: 0,
            discount_on_consultation_fee_in_rupees: 0,
            discount_percent: 0,
            fee_in_rupees: response.data.data.fee_in_rupees,
            gst_in_rupees: 0,
            igst_percent: response.data.data.igst_percent
              ? response.data.data.igst_percent
              : 0,
            inputValue: 0,
            procedure_id: response.data.data.procedure_id,
            procedure_name: response.data.data.procedure_name,
            sgst_percent: response.data.data.sgst_percent
              ? response.data.data.sgst_percent
              : 0,
            subtotal_in_rupees: response.data.data.subtotal_in_rupees,
            total_fee_in_rupees: response.data.data.subtotal_in_rupees,
            refund_in_rupees: 0,
            final_amount_in_rupees: response.data.data.subtotal_in_rupees,
            is_deleted: false,
          };
          setNewProcedureDetails(markers);
          procedureRowsmarkers[index]["subtotal_in_rupees"] =
            response.data.data.subtotal_in_rupees;

          procedureRowsmarkers[index]["consultation_fee_in_rupees"] =
            response.data.data.fee_in_rupees;
          let byCash =
            appointmentDetails.payment_method === "Paid at Clinic - By Cash";
          setAmountToBePaidAtClinic(
            procedureRowsmarkers.reduce(
              (a, v) =>
                (a = a + (!v.is_deleted ? v.final_amount_in_rupees : 0)),
              0
            ) + (byCash ? appointmentDetails.final_amount_in_rupees : 0)
          );
          setConsultationFeeInRupeesAtClinic(
            procedureRowsmarkers.reduce(
              (a, v) => (a = a + (!v.is_deleted ? v.fee_in_rupees : 0)),
              0
            ) + (byCash ? appointmentDetails.fee_in_rupees : 0)
          );
          setProcedureRows(procedureRowsmarkers);
          let disableSub = procedureRowsmarkers.every(
            (tr) => tr.consultation_name !== ""
          );
          setDisableSubmit(!disableSub);
          if (paymentMethod === "online") {
            setPaymentMethod("Cash");
          }
          setloader(false);
        }
      })
      .catch((err) => C2CConsole.log(err));
  };

  const renderDocument = (width) => {
    if (documentShow) {
      return (
        <DocumentContainer
          cancelHandler={() => closeNotification()}
          url={`${fileDetails?.fileURL}`}
          fileName={fileDetails?.fileName}
          fileType={fileDetails?.fileType}
          width={width || ""}
        />
      );
    }
  };

  const closeNotification = () => {
    setDocumentShow(false);
    setFileDetails({
      fileName: "",
      fileURL: "",
      fileType: `${fileDetails?.fileType}`,
    });
    props.refreshAppointmentsMethod();
  };
  const printReceipt = () => {
    setSuccessMarkModal(false);
    setDocumentShow(true);
  };

  const onRaiseInvoiceClose = () => {
    props.closeView();
    setReferenceId("");
    setSpecifyOther(false);
    setSpecifyOtherPaymentText("");
    setPaymentMethod("");
  };

  return (
    <>
      {loader ? <Loader /> : ""}
      {props.openView ? (
        <Drawer
          anchor={"right"}
          open={props.openView}
          onClose={props.closeView}
          className="mark_check_in_drawer"
        >
          {loading ? (
            <div className="my-3 text-center">
              <Spinner animation="border" variant="secondary" />
            </div>
          ) : (
            <form onSubmit={markCheckIn}>
              <div className="mark_check_drower_main_cont">
                <div className="mark_check_drower_heading">
                  <div className="d-flex justify-content-between heading align-items-center">
                    <div className="d-flex align-items-center">
                      <h4 className="mb-0 align-self-center header-title">
                        {"Raise Invoice "}
                      </h4>
                      <small
                        data-tooltip="Confirm the details and click the submit option to raise an invoice.This will appear on my appointments and transactions."
                        data-tooltip-conf="multiline bottom"
                      >
                        <img src={Info} className="ml-2" alt="info" />
                      </small>
                    </div>
                    <img
                      className="closeIcon-text"
                      src={CloseIconWithText}
                      alt=""
                      onClick={onRaiseInvoiceClose}
                    />
                  </div>
                  <div>
                    <p className="mb-2 review_and_confirm">
                      Review and confirm billing information for your patient.
                    </p>
                  </div>
                </div>
                <div className="b-top">
                  <div className="patient-details">
                    <div className="patient-details-name patient-details-content b-right">
                      Patient : {appointmentDetails?.patient_name}
                    </div>
                    {appointmentDetails?.formatted_uhid && (
                      <div
                        className="patient_uhid patient-details-content pr-1 b-right"
                        style={{
                          overflowWrap: "anywhere",
                          textAlign: "inherit",
                        }}
                      >
                        {appointmentDetails?.formatted_uhid}
                      </div>
                    )}
                    <div className="patient_mobileno patient-details-content pr-1 b-right">
                      {appointmentDetails?.phone_no}
                    </div>
                    <div className="patient-details-content patient_consultation_date ml-1">
                      {appointmentDetails?.appointment_date != "" &&
                        appointmentDetails?.appointment_start_time != "" &&
                        `${
                          moment(appointmentDetails?.appointment_date).format(
                            "MMM DD, YYYY"
                          ) +
                          " at " +
                          moment(
                            appointmentDetails?.appointment_start_time,
                            "hh:mm:ssZ"
                          ).format("hh:mm A")
                        }`}
                    </div>
                  </div>
                </div>
                <div className="mark-check mark_check_middle_part b-top">
                  <div className="row info m-0 mb-2">
                    <div className="col-12 mb-2 mt-2 info-header">
                      CONSULTATION DETAILS
                    </div>
                    <div className="col-12 mb-2 accordian_css_desktop">
                      <div className="consultion_header">
                        <div className="col_item consultion_heading_name">
                          Procedure
                        </div>
                        <div className="col_item">Fee</div>
                        <div className="col_item">IGST</div>
                        <div className="col_item">CGST</div>
                        <div className="col_item">SGST</div>
                        <div className="col_item" style={{ minWidth: "70px" }}>
                          Subtotal
                        </div>
                        <div className="col_item" style={{ minWidth: "75px" }}>
                          Discount
                        </div>
                        <div className="col_item">Total</div>
                        <div className="col_item">Refund</div>
                        <div className="col_item" style={{ minWidth: "88px" }}>
                          Final Amount
                        </div>
                      </div>
                      <div className="consultion_body">
                        <div
                          className="col_item consultion_heading_name select_style"
                          style={{ paddingRight: "20px" }}
                        >
                          {appointmentDetails.payment_method ===
                          "Paid at Clinic - By Cash" ? (
                            <div className="default_procedure">
                              <span
                                style={{
                                  padding: "2px 8px",
                                  width: "80%",
                                  color: "rgba(0, 0, 0, 0.6)",
                                }}
                              >
                                {renderConsultationType(
                                  appointmentDetails.appointment_type,
                                  appointmentDetails.consultation_type,
                                  appointmentDetails.procedure_name
                                )}
                              </span>
                              <div className="separator">
                                <span className="react-select__indicator-separator css-1okebmr-indicatorSeparator"></span>
                                <div
                                  class="react-select__indicator react-select__dropdown-indicator css-tlfecz-indicatorContainer"
                                  aria-hidden="true"
                                  style={{
                                    padding: "5px",
                                    paddingLeft: "10px",
                                  }}
                                >
                                  <i
                                    className="fa fa-caret-down"
                                    style={{ color: "hsl(0, 0%, 70%)" }}
                                  ></i>
                                </div>
                              </div>
                            </div>
                          ) : (
                            renderConsultationType(
                              appointmentDetails.appointment_type,
                              appointmentDetails.consultation_type,
                              appointmentDetails.procedure_name
                            )
                          )}
                        </div>
                        <div className="col_item">
                          {appointmentDetails.payment_method ===
                          "Paid at Clinic - By Cash" ? (
                            <input
                              type="tell"
                              min="0"
                              max="100"
                              onKeyPress={(event) => {
                                if (!/[0-9]/.test(event.key)) {
                                  event.preventDefault();
                                }
                              }}
                              className="discount_input"
                              value={appointmentDetails.fee_in_rupees}
                              placeholder="0"
                              onChange={(e) => applyDefaultFee(e)}
                              autoComplete="off"
                            />
                          ) : (
                            <div>
                              <span>₹</span>
                              {appointmentDetails?.fee_in_rupees == null
                                ? 0
                                : appointmentDetails.fee_in_rupees}
                            </div>
                          )}
                        </div>
                        <div className="col_item">
                          {appointmentDetails?.igst_percent == null ? (
                            0
                          ) : (
                            <span>
                              {appointmentDetails.igst_percent}
                              {appointmentDetails.igst_percent ? "%" : ""}
                            </span>
                          )}
                        </div>
                        <div className="col_item">
                          {appointmentDetails?.cgst_percent == null ? (
                            0
                          ) : (
                            <span>
                              {appointmentDetails.cgst_percent}
                              {appointmentDetails.cgst_percent ? "%" : ""}
                            </span>
                          )}
                        </div>
                        <div className="col_item">
                          {appointmentDetails?.sgst_percent == null ? (
                            0
                          ) : (
                            <span>
                              {appointmentDetails.sgst_percent}
                              {appointmentDetails.sgst_percent ? "%" : ""}
                            </span>
                          )}
                        </div>
                        <div className="col_item" style={{ minWidth: "70px" }}>
                          <span>₹</span>
                          {appointmentDetails?.subtotal_in_rupees == null
                            ? 0
                            : appointmentDetails.subtotal_in_rupees}
                        </div>
                        <div className="col_item" style={{ minWidth: "75px" }}>
                          {appointmentDetails.payment_method ===
                          "Paid at Clinic - By Cash" ? (
                            <div class="percentInput">
                              <input
                                type="tell"
                                maxlength="4"
                                min="0"
                                max="100"
                                onKeyPress={(event) => {
                                  if (!/[0-9]/.test(event.key)) {
                                    event.preventDefault();
                                  }
                                }}
                                className="discount_input"
                                value={appointmentDetails.discount_percent}
                                placeholder="0"
                                onChange={(e) => applyDefaultDiscount(e)}
                                autoComplete="off"
                              />
                              <span>%</span>
                            </div>
                          ) : (
                            <span>
                              {appointmentDetails?.discount_percent == null
                                ? 0 + "%"
                                : appointmentDetails.discount_percent + "%"}
                            </span>
                          )}
                        </div>
                        <div className="col_item total_amount_css">
                          <span>₹</span>
                          {appointmentDetails?.total_fee_in_rupees == null
                            ? 0
                            : appointmentDetails?.total_fee_in_rupees}
                        </div>
                        <div className="col_item">
                          {appointmentDetails.payment_method ===
                          "Paid at Clinic - By Cash" ? (
                            <input
                              type="tell"
                              min="0"
                              max="100"
                              onKeyPress={(event) => {
                                if (!/[0-9]/.test(event.key)) {
                                  event.preventDefault();
                                }
                              }}
                              className="discount_input"
                              value={appointmentDetails.refund_in_rupees}
                              placeholder="0"
                              onChange={(e) => applyDefaultRefund(e)}
                              autoComplete="off"
                            />
                          ) : (
                            appointmentDetails.refund_in_rupees
                          )}
                        </div>
                        <div
                          className="col_item total_amount_css"
                          style={{ minWidth: "88px" }}
                        >
                          <span>₹</span>
                          {appointmentDetails?.final_amount_in_rupees}
                        </div>
                      </div>
                      {procedureRows?.map((procedurePerRow, index) => {
                        if (procedurePerRow && !procedurePerRow.is_deleted) {
                          return (
                            <div className="consultion_body slected_consultion_body">
                              <div className="col_item consultion_heading_name">
                                <CustomSelect
                                  className="select_style"
                                  showSearch={true}
                                  placeholder=""
                                  value={getDoctorConsultationTypeList.filter(
                                    (option) => {
                                      return (
                                        option.label ===
                                        (procedurePerRow.procedure_name
                                          ? procedurePerRow.procedure_name.includes(
                                              "followup"
                                            )
                                            ? "In-clinic Follow-up"
                                            : procedurePerRow.procedure_name.includes(
                                                "regular"
                                              )
                                            ? "In-clinic Regular"
                                            : procedurePerRow.procedure_name
                                          : procedurePerRow.consultation_name.includes(
                                              "followup"
                                            )
                                          ? "In-clinic Follow-up"
                                          : procedurePerRow.consultation_name.includes(
                                              "regular"
                                            )
                                          ? "In-clinic Regular"
                                          : "")
                                      );
                                    }
                                  )}
                                  options={getDoctorConsultationTypeList}
                                  handleChange={(opt) =>
                                    DoctorConsultationTypeListHandleSelect(
                                      opt,
                                      index
                                    )
                                  }
                                  fixedBottomBtn={false}
                                  isSearchable={false}
                                />
                              </div>
                              <div className="col_item">
                                {procedurePerRow.consultation_name === "" ? (
                                  0
                                ) : (
                                  <input
                                    type="tell"
                                    min="0"
                                    max="100"
                                    onKeyPress={(event) => {
                                      if (!/[0-9]/.test(event.key)) {
                                        event.preventDefault();
                                      }
                                    }}
                                    className="discount_input"
                                    column={index + 1}
                                    value={procedurePerRow.fee_in_rupees}
                                    index={index}
                                    placeholder="0"
                                    onChange={(e) => applyFee(e, index)}
                                    autoComplete="off"
                                  />
                                )}
                              </div>
                              <div className="col_item">
                                {procedurePerRow.igst_percent}
                                {procedurePerRow.igst_percent &&
                                procedurePerRow.igst_percent !== 0 ? (
                                  <span>%</span>
                                ) : null}
                              </div>
                              <div className="col_item">
                                {procedurePerRow.cgst_percent}
                                {procedurePerRow.cgst_percent &&
                                procedurePerRow.cgst_percent !== 0 ? (
                                  <span>%</span>
                                ) : null}
                              </div>
                              <div className="col_item">
                                {procedurePerRow.sgst_percent}
                                {procedurePerRow.sgst_percent &&
                                procedurePerRow.sgst_percent !== 0 ? (
                                  <span>%</span>
                                ) : null}
                              </div>
                              <div
                                className="col_item"
                                style={{ minWidth: "70px" }}
                              >
                                <span>₹</span>
                                {procedurePerRow.subtotal_in_rupees
                                  ? procedurePerRow.subtotal_in_rupees
                                  : 0}
                              </div>
                              <div
                                className="col_item"
                                key={index}
                                style={{ minWidth: "75px" }}
                              >
                                {procedurePerRow.consultation_name === "" ? (
                                  0
                                ) : (
                                  <div class="percentInput">
                                    <input
                                      type="tell"
                                      maxlength="4"
                                      min="0"
                                      max="100"
                                      onKeyPress={(event) => {
                                        if (!/[0-9]/.test(event.key)) {
                                          event.preventDefault();
                                        }
                                      }}
                                      className="discount_input"
                                      column={index + 1}
                                      value={
                                        procedurePerRow?.discount_percent ==
                                        null
                                          ? 0
                                          : procedurePerRow.discount_percent
                                      }
                                      index={index}
                                      placeholder="0"
                                      onChange={(e) => applyDiscount(e, index)}
                                      autoComplete="off"
                                    />
                                    <span>%</span>
                                  </div>
                                )}
                              </div>
                              <div className="col_item total_amount_css">
                                <span>₹</span>
                                {procedurePerRow.total_fee_in_rupees
                                  ? procedurePerRow.total_fee_in_rupees
                                  : 0}
                              </div>
                              <div className="col_item">
                                {procedurePerRow.consultation_name === "" ? (
                                  0
                                ) : (
                                  <input
                                    type="tell"
                                    min="0"
                                    max="100"
                                    onKeyPress={(event) => {
                                      if (!/[0-9]/.test(event.key)) {
                                        event.preventDefault();
                                      }
                                    }}
                                    className="discount_input"
                                    column={index + 1}
                                    value={
                                      procedurePerRow?.refund_in_rupees == null
                                        ? 0
                                        : procedurePerRow.refund_in_rupees
                                    }
                                    index={index}
                                    placeholder="0"
                                    onChange={(e) => applyRefund(e, index)}
                                    autoComplete="off"
                                  />
                                )}
                              </div>
                              <div
                                className="col_item total_amount_css"
                                style={{ minWidth: "88px" }}
                              >
                                <span style={{ flex: "1" }}>
                                  <span>₹</span>
                                  {procedurePerRow.final_amount_in_rupees
                                    ? procedurePerRow.final_amount_in_rupees
                                    : 0}
                                </span>
                                <span
                                  onClick={() => deleteProcedureRows(index)}
                                  style={{ cursor: "pointer" }}
                                >
                                  <img
                                    src={deletRedIcon}
                                    style={{ width: "16px" }}
                                  />
                                </span>
                              </div>
                            </div>
                          );
                        }
                      })}
                      <div className="add_procedure">
                        <span onClick={addNewProcedureRow}>
                          + Add Procedure
                        </span>
                      </div>
                    </div>
                    <div className="col-12 mb-2 accordian_css_mobile">
                      <div id="accordion" className="col-12 accordion p-0">
                        <div className="card-container">
                          <div
                            className={`card-header ${
                              procedureRows.length <= 1 ? "" : "collapsed"
                            }`}
                            data-toggle="collapse"
                            href="#in_clinic_regular"
                          >
                            <span className="circle_plus_minus"></span>
                            {appointmentDetails.payment_method ===
                            "Paid at Clinic - By Cash" ? (
                              <div
                                className="default_procedure"
                                style={{ marginRight: "98px" }}
                              >
                                <span
                                  className="card-title"
                                  style={{
                                    padding: "2px 8px",
                                    width: "80%",
                                    color: "rgba(0, 0, 0, 0.6)",
                                  }}
                                >
                                  {renderConsultationType(
                                    appointmentDetails.appointment_type,
                                    appointmentDetails.consultation_type,
                                    appointmentDetails.procedure_name
                                  )}
                                </span>
                                <div className="separator">
                                  <span className="react-select__indicator-separator css-1okebmr-indicatorSeparator"></span>
                                  <div
                                    class="react-select__indicator react-select__dropdown-indicator css-tlfecz-indicatorContainer"
                                    aria-hidden="true"
                                    style={{
                                      padding: "5px",
                                      paddingLeft: "10px",
                                    }}
                                  >
                                    <i
                                      className="fa fa-caret-down"
                                      style={{ color: "hsl(0, 0%, 70%)" }}
                                    ></i>
                                  </div>
                                </div>
                              </div>
                            ) : (
                              <a className="card-title">
                                {renderConsultationType(
                                  appointmentDetails.appointment_type,
                                  appointmentDetails.consultation_type,
                                  appointmentDetails.procedure_name
                                )}
                              </a>
                            )}
                          </div>
                          <div
                            id="in_clinic_regular"
                            className={`card-body collapse ${
                              procedureRows.length <= 1 ? "show" : ""
                            }`}
                            data-parent="#accordion"
                          >
                            <div className="tab_content_top">
                              <div className="consultion_header">
                                <div className="col_item">Fee</div>
                                <div className="col_item">IGST</div>
                                <div className="col_item">CGST</div>
                                <div className="col_item">SGST</div>
                              </div>
                              <div className="consultion_body">
                                <div className="col_item">
                                  {appointmentDetails.payment_method ===
                                  "Paid at Clinic - By Cash" ? (
                                    <input
                                      type="tell"
                                      min="0"
                                      max="100"
                                      onKeyPress={(event) => {
                                        if (!/[0-9]/.test(event.key)) {
                                          event.preventDefault();
                                        }
                                      }}
                                      className="discount_input"
                                      value={appointmentDetails.fee_in_rupees}
                                      placeholder="0"
                                      onChange={(e) => applyDefaultFee(e)}
                                      autoComplete="off"
                                    />
                                  ) : (
                                    <div>
                                      <span>₹</span>
                                      {appointmentDetails?.fee_in_rupees == null
                                        ? 0
                                        : appointmentDetails.fee_in_rupees}
                                    </div>
                                  )}
                                </div>
                                <div className="col_item">
                                  {appointmentDetails?.igst_percent == null ? (
                                    0
                                  ) : (
                                    <span>
                                      {appointmentDetails.igst_percent}
                                      {appointmentDetails.igst_percent
                                        ? "%"
                                        : ""}
                                    </span>
                                  )}
                                </div>
                                <div className="col_item">
                                  {appointmentDetails?.cgst_percent == null ? (
                                    0
                                  ) : (
                                    <span>
                                      {appointmentDetails.cgst_percent}
                                      {appointmentDetails.cgst_percent
                                        ? "%"
                                        : ""}
                                    </span>
                                  )}
                                </div>
                                <div className="col_item">
                                  {appointmentDetails?.sgst_percent == null ? (
                                    0
                                  ) : (
                                    <span>
                                      {appointmentDetails.sgst_percent}
                                      {appointmentDetails.sgst_percent
                                        ? "%"
                                        : ""}
                                    </span>
                                  )}
                                </div>
                              </div>
                            </div>
                            <div className="tab_content_middle">
                              <div className="consultion_header">
                                <div className="col_item">Subtotal</div>
                                <div className="col_item">Discount</div>
                                <div className="col_item">Refund</div>
                                <div className="col_item">F.Amount</div>
                              </div>
                              <div className="consultion_body">
                                <div className="col_item">
                                  <span>₹</span>
                                  {appointmentDetails?.subtotal_in_rupees ==
                                  null
                                    ? 0
                                    : appointmentDetails.subtotal_in_rupees}
                                </div>
                                <div className="col_item">
                                  {appointmentDetails.payment_method ===
                                  "Paid at Clinic - By Cash" ? (
                                    <div class="percentInput">
                                      <input
                                        type="tell"
                                        maxlength="4"
                                        min="0"
                                        max="100"
                                        onKeyPress={(event) => {
                                          if (!/[0-9]/.test(event.key)) {
                                            event.preventDefault();
                                          }
                                        }}
                                        className="discount_input"
                                        value={
                                          appointmentDetails.discount_percent
                                        }
                                        placeholder="0"
                                        onChange={(e) =>
                                          applyDefaultDiscount(e)
                                        }
                                        autoComplete="off"
                                      />
                                      <span>%</span>
                                    </div>
                                  ) : (
                                    <span>
                                      {appointmentDetails?.discount_percent ==
                                      null
                                        ? 0 + "%"
                                        : appointmentDetails.discount_percent +
                                          "%"}
                                    </span>
                                  )}
                                </div>
                                <div className="col_item">
                                  {appointmentDetails.payment_method ===
                                  "Paid at Clinic - By Cash" ? (
                                    <input
                                      type="tell"
                                      min="0"
                                      max="100"
                                      onKeyPress={(event) => {
                                        if (!/[0-9]/.test(event.key)) {
                                          event.preventDefault();
                                        }
                                      }}
                                      className="discount_input"
                                      value={
                                        appointmentDetails.refund_in_rupees
                                      }
                                      placeholder="0"
                                      onChange={(e) => applyDefaultRefund(e)}
                                      autoComplete="off"
                                    />
                                  ) : (
                                    appointmentDetails.refund_in_rupees
                                  )}
                                </div>
                                <div className="col_item total_amount_css">
                                  <span>₹</span>
                                  {appointmentDetails.final_amount_in_rupees}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        {procedureRows?.map((procedurePerRow, index) => {
                          if (procedurePerRow && !procedurePerRow.is_deleted) {
                            return (
                              <div className="card-container">
                                <div
                                  className="card-header"
                                  data-toggle={`${
                                    procedureTrue ? "collapse" : ""
                                  }`}
                                  data-parent="#accordion"
                                  href={`#slected_procedure_${index}`}
                                >
                                  <span className="circle_plus_minus"></span>
                                  <a
                                    className="card-title"
                                    style={{ paddingRight: "80px" }}
                                  >
                                    <CustomSelect
                                      className="select_style"
                                      showSearch={true}
                                      placeholder=""
                                      value={getDoctorConsultationTypeList.filter(
                                        (option) => {
                                          return (
                                            option.label ===
                                            (procedurePerRow.procedure_name
                                              ? procedurePerRow.procedure_name.includes(
                                                  "followup"
                                                )
                                                ? "In-clinic Follow-up"
                                                : procedurePerRow.procedure_name.includes(
                                                    "regular"
                                                  )
                                                ? "In-clinic Regular"
                                                : procedurePerRow.procedure_name
                                              : procedurePerRow.consultation_name.includes(
                                                  "followup"
                                                )
                                              ? "In-clinic Follow-up"
                                              : procedurePerRow.consultation_name.includes(
                                                  "regular"
                                                )
                                              ? "In-clinic Regular"
                                              : "")
                                          );
                                        }
                                      )}
                                      options={getDoctorConsultationTypeList}
                                      handleChange={(opt) =>
                                        DoctorConsultationTypeListHandleSelect(
                                          opt,
                                          index
                                        )
                                      }
                                      fixedBottomBtn={false}
                                      isSearchable={false}
                                    />
                                  </a>
                                  <span
                                    onClick={() => deleteProcedureRows(index)}
                                    style={{ cursor: "pointer" }}
                                  >
                                    <img src={deletRedIcon} />
                                  </span>
                                </div>
                                <div
                                  id={`slected_procedure_${index}`}
                                  className={`card-body collapse show ${
                                    procedureTrue ? "" : "show"
                                  }`}
                                  data-parent="#accordion"
                                >
                                  <div className="tab_content_top">
                                    <div className="consultion_header">
                                      <div className="col_item">Fee</div>
                                      <div className="col_item">IGST</div>
                                      <div className="col_item">CGST</div>
                                      <div className="col_item">SGST</div>
                                    </div>
                                    <div className="consultion_body">
                                      <div className="col_item">
                                        <span>₹</span>
                                        {procedurePerRow.consultation_name ===
                                        "" ? (
                                          0
                                        ) : (
                                          <input
                                            type="tell"
                                            min="0"
                                            max="100"
                                            onKeyPress={(event) => {
                                              if (!/[0-9]/.test(event.key)) {
                                                event.preventDefault();
                                              }
                                            }}
                                            className="discount_input"
                                            column={index + 1}
                                            value={
                                              procedurePerRow.fee_in_rupees
                                            }
                                            index={index}
                                            placeholder="0"
                                            onChange={(e) => applyFee(e, index)}
                                            autoComplete="off"
                                          />
                                        )}
                                      </div>
                                      <div className="col_item">
                                        {procedurePerRow.igst_percent}
                                        {procedurePerRow.igst_percent &&
                                        procedurePerRow.igst_percent !== 0 ? (
                                          <span>%</span>
                                        ) : null}
                                      </div>
                                      <div className="col_item">
                                        {procedurePerRow.cgst_percent}
                                        {procedurePerRow.cgst_percent &&
                                        procedurePerRow.cgst_percent !== 0 ? (
                                          <span>%</span>
                                        ) : null}
                                      </div>
                                      <div className="col_item">
                                        {procedurePerRow.sgst_percent}
                                        {procedurePerRow.sgst_percent &&
                                        procedurePerRow.sgst_percent !== 0 ? (
                                          <span>%</span>
                                        ) : null}
                                      </div>
                                    </div>
                                  </div>
                                  <div className="tab_content_middle">
                                    <div className="consultion_header">
                                      <div className="col_item">Subtotal</div>
                                      <div className="col_item">Discount</div>
                                      <div className="col_item">Refund</div>
                                      <div className="col_item">F.Amount</div>
                                    </div>
                                    <div className="consultion_body">
                                      <div className="col_item">
                                        <span>₹</span>
                                        {procedurePerRow.subtotal_in_rupees
                                          ? procedurePerRow.subtotal_in_rupees
                                          : 0}
                                      </div>
                                      <div className="col_item" key={index}>
                                        {procedurePerRow.consultation_name ===
                                        "" ? (
                                          0 + "%"
                                        ) : (
                                          <input
                                            type="tell"
                                            maxlength="4"
                                            min="0"
                                            max="100"
                                            onKeyPress={(event) => {
                                              if (!/[0-9]/.test(event.key)) {
                                                event.preventDefault();
                                              }
                                            }}
                                            className="discount_input"
                                            column={index + 1}
                                            value={
                                              procedurePerRow?.discount_percent ==
                                              null
                                                ? 0 + "%"
                                                : procedurePerRow.discount_percent +
                                                  "%"
                                            }
                                            index={index}
                                            placeholder="0"
                                            onChange={(e) =>
                                              applyDiscount(e, index)
                                            }
                                            autoComplete="off"
                                            style={{ maxWidth: "60px" }}
                                          />
                                        )}
                                      </div>
                                      <div className="col_item">
                                        {procedurePerRow.consultation_name ===
                                        "" ? (
                                          0
                                        ) : (
                                          <input
                                            type="tell"
                                            min="0"
                                            max="100"
                                            onKeyPress={(event) => {
                                              if (!/[0-9]/.test(event.key)) {
                                                event.preventDefault();
                                              }
                                            }}
                                            className="discount_input"
                                            column={index + 1}
                                            value={
                                              procedurePerRow?.refund_in_rupees ==
                                              null
                                                ? 0
                                                : procedurePerRow.refund_in_rupees
                                            }
                                            index={index}
                                            placeholder="0"
                                            onChange={(e) =>
                                              applyRefund(e, index)
                                            }
                                            autoComplete="off"
                                          />
                                        )}
                                      </div>
                                      <div className="col_item total_amount_css">
                                        <span>₹</span>
                                        {procedurePerRow.final_amount_in_rupees
                                          ? procedurePerRow.final_amount_in_rupees
                                          : 0}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            );
                          }
                        })}
                      </div>
                      <div className="add_procedure">
                        <span onClick={addNewProcedureRow}>
                          + Add Procedure
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className="row m-0 ">
                    <div className="col-12 ">
                      <div className="payment_summary_countery">
                        <div className="payment_summary mb-2">
                          PAYMENT SUMMARY
                        </div>
                        <div id="accordion" className="accordion">
                          {appointmentDetails.payment_method !==
                          "Paid at Clinic - By Cash" ? (
                            <div className="card-container">
                              <div
                                className={`card-header ${
                                  procedureRows.length < 1 ? "" : "collapsed"
                                }`}
                                data-toggle="collapse"
                                href="#collapseOne"
                              >
                                <span className="circle_plus_minus"></span>
                                <a className="card-title">
                                  <span className="card_title_name">
                                    Amount Paid (Online via C2C)
                                  </span>
                                  <span>
                                    <span>₹</span>
                                    {appointmentDetails?.total_fee_in_rupees}
                                  </span>
                                </a>
                              </div>
                              <div
                                id="collapseOne"
                                className={`card-body collapse ${
                                  procedureRows.length < 1 ? "show" : ""
                                }`}
                                data-parent="#accordion"
                              >
                                <div className="payment_summary_details">
                                  <div className="payment_summary_row">
                                    <p className="col_item_first">
                                      Consultation Fee
                                    </p>
                                    <p>
                                      <span>₹</span>
                                      {appointmentDetails?.consultation_fee_in_rupees ==
                                      null
                                        ? 0
                                        : appointmentDetails.consultation_fee_in_rupees}
                                    </p>
                                  </div>
                                  <div className="payment_summary_row">
                                    <p className="col_item_first">
                                      Convenience Fee
                                    </p>
                                    <p>
                                      <span>₹</span>
                                      {appointmentDetails?.convenience_fee_in_rupees ==
                                      null
                                        ? 0
                                        : appointmentDetails.convenience_fee_in_rupees}
                                    </p>
                                  </div>
                                  <div className="payment_summary_row">
                                    <p className="col_item_first">GST</p>
                                    <p>
                                      <span>₹</span>
                                      {appointmentDetails?.gst_in_rupees == null
                                        ? 0
                                        : appointmentDetails.gst_in_rupees}
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </div>
                          ) : (
                            ""
                          )}
                          {!hidePaymentMode ? (
                            <div className="card-container">
                              <div
                                className="card-header"
                                data-toggle="collapse"
                                data-parent="#accordion"
                                href="#collapseTwo"
                              >
                                <span className="circle_plus_minus"></span>
                                <a className="card-title">
                                  <span className="card_title_name">
                                    Amount To Be Paid (Pay at Clinic)
                                  </span>
                                  <span>
                                    <span>₹</span>
                                    {Math.ceil(amountToBePaidAtClinic)}
                                  </span>
                                </a>
                              </div>
                              <div
                                id="collapseTwo"
                                className="card-body collapse show"
                                data-parent="#accordion"
                              >
                                <div className="payment_summary_details">
                                  <div className="payment_summary_row">
                                    <p className="col_item_first">
                                      Consultation Fee
                                    </p>
                                    <p>
                                      <span>₹</span>
                                      {consultationFeeInRupeesAtClinic}
                                    </p>
                                  </div>
                                  {inputValue !== 0 &&
                                  parseFloat(discountAtClinic.toFixed(1)) !==
                                    0 ? (
                                    <div className="payment_summary_row discounted_summary_row">
                                      <p className="col_item_first">Discount</p>
                                      <p>
                                        <span>-₹</span>
                                        {parseFloat(
                                          discountAtClinic.toFixed(1)
                                        )}
                                      </p>
                                    </div>
                                  ) : (
                                    ""
                                  )}
                                  {totalRefund ? (
                                    <div
                                      className="payment_summary_row"
                                      style={{
                                        color: "#17bae0",
                                        fontWeight: "bold",
                                      }}
                                    >
                                      <p className="col_item_first">Refund</p>
                                      <p>
                                        <span>-₹</span>
                                        {totalRefund}
                                      </p>
                                    </div>
                                  ) : null}
                                  {parseFloat(
                                    (
                                      Math.ceil(
                                        Number(amountToBePaidAtClinic)
                                      ) -
                                      parseFloat(
                                        Number(amountToBePaidAtClinic).toFixed(
                                          1
                                        )
                                      )
                                    ).toFixed(1)
                                  ) !== 0 ? (
                                    <div className="payment_summary_row">
                                      <p className="col_item_first">
                                        Round off Amount
                                      </p>
                                      <p>
                                        <span>+₹</span>
                                        {parseFloat(
                                          (
                                            Math.ceil(
                                              Number(amountToBePaidAtClinic)
                                            ) -
                                            parseFloat(
                                              Number(
                                                amountToBePaidAtClinic
                                              ).toFixed(1)
                                            )
                                          ).toFixed(1)
                                        )}
                                      </p>
                                    </div>
                                  ) : null}
                                </div>
                              </div>
                            </div>
                          ) : (
                            ""
                          )}
                          <div className="total_payment_summary_row">
                            <p className="col_item_first">TOTAL FEE</p>
                            <p>
                              <span>₹</span>
                              {Math.ceil(
                                Number(amountToBePaidAtClinic) +
                                  (appointmentDetails?.payment_method !==
                                  "Paid at Clinic - By Cash"
                                    ? Number(
                                        appointmentDetails.final_amount_in_rupees
                                      )
                                    : 0)
                              )}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  {!hidePaymentMode ? (
                    <div className="row info m-0 mb-2">
                      <div className="col-12">
                        <p className="label mb-0 payment_method">
                          PAYMENT METHOD FOR AMOUNT TO BE PAID
                        </p>
                      </div>
                      <div className="col-6 mt-2 mb-2">
                        {!isSpecifyOther ? (
                          <Select
                            className="select_style"
                            onChange={(value) => {
                              handleSelect(value);
                            }}
                            value={paymentOptions.filter((option) => {
                              return option.value === paymentMethod;
                            })}
                            styles={customStyles}
                            placeholder="By Cash"
                            options={paymentOptions}
                            components={{ DropdownIndicator }}
                          />
                        ) : (
                          <div className="search-wrapper">
                            <input
                              type="text"
                              required="required"
                              className="inputSearch"
                              value={specifyOtherPaymentText}
                              placeholder="Specify Other"
                              onChange={(e) => {
                                setSpecifyOtherPaymentText(e.target.value);
                                setPaymentMethod(e.target.value);
                              }}
                            />
                            <img
                              src={closeIcon}
                              alt="close"
                              onClick={() => {
                                setSpecifyOther(false);
                                setPaymentMethod("");
                              }}
                            />
                          </div>
                        )}
                      </div>
                      <div className="col-6 mt-2 mb-2">
                        <input
                          className="inputField"
                          type="text"
                          name="remark"
                          value={referenceId}
                          placeholder="Transaction/Reference ID"
                          onChange={(e) => setReferenceId(e.target.value)}
                        />
                      </div>
                    </div>
                  ) : (
                    ""
                  )}
                </div>
              </div>
              <div className="row m-0 shadow-container">
                <div
                  className="align-self-center totalAmount"
                  style={{ flex: "1" }}
                >
                  Total Fee : ₹
                  {Math.ceil(
                    Number(amountToBePaidAtClinic) +
                      (appointmentDetails?.payment_method !==
                      "Paid at Clinic - By Cash"
                        ? Number(appointmentDetails.final_amount_in_rupees)
                        : 0)
                  )}
                </div>

                <button
                  type="submit"
                  className="btn btn-sm primary-cta-button rounded-pill py-2 px-5 submit-btn"
                  disabled={
                    disableSubmit ||
                    (appointmentDetails?.payment_method ===
                      "Paid at Clinic - By Cash" &&
                      (paymentMethod === "" ||
                        (paymentMethod === "Other" &&
                          specifyOtherPaymentText?.length === 0) ||
                        loading))
                      ? true
                      : false
                  }
                  onClick={markCheckIn}
                >
                  Submit
                </button>
              </div>
            </form>
          )}
        </Drawer>
      ) : null}
      {renderDocument("98%")}
      {showSuccessMarkModal && (
        <MarkCheckInSuccessModal
          appointmentDetails={appointmentDetails}
          openView={showSuccessMarkModal}
          invoiceUrl={invoiceUrl}
          completionTime={completionTime}
          printInvoice={printReceipt}
          dashboardRaiseInvoiceSuccessModal={true}
          closeView={() => {
            setSuccessMarkModal(false);
            props.refreshAppointmentsMethod();
          }}
        />
      )}
    </>
  );
}
